import React from "react";

function ProductManagmentIcon({ fill = "#424242", size = "20px" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3119_3820)">
        <path
          d="M9.1 19C8.3638 19 7.66 18.703 6.2533 18.109C2.7514 16.6294 1 15.8887 1 14.644V5.5M9.1 19V9.4195M9.1 19C9.7525 19 10.2637 18.766 11.35 18.3007M17.2 5.5V9.1"
          stroke={fill}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7 14.9508H19M15.85 18.1008V11.8008"
          stroke={fill}
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          d="M3.7 10L5.5 10.9M13.6 2.8L4.6 7.3M5.7934 7.9219L3.1645 6.6502C1.7218 5.9518 1 5.6026 1 5.05C1 4.4974 1.7218 4.1482 3.1645 3.4498L5.7925 2.1781C7.417 1.3924 8.227 1 9.1 1C9.973 1 10.7839 1.3924 12.4066 2.1781L15.0355 3.4498C16.4782 4.1482 17.2 4.4974 17.2 5.05C17.2 5.6026 16.4782 5.9518 15.0355 6.6502L12.4075 7.9219C10.783 8.7076 9.973 9.1 9.1 9.1C8.227 9.1 7.4161 8.7076 5.7934 7.9219Z"
          stroke={fill}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3119_3820">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ProductManagmentIcon;
